import {setOrFallbackValue} from './helper';
import FittingStationAddress from './fitting_station_address';
export default class FittingOption {
    constructor(props) {
        this.fsId = setOrFallbackValue(props, 'fsId', null);
        this.isMobile = setOrFallbackValue(props, 'isMobile', false);
        this.name = setOrFallbackValue(props, 'name', null);
        this.address = (null === setOrFallbackValue(props, 'address', null)) ?
            {} : new FittingStationAddress(props.address);
    }
}
